<template>
    <div class="pt-14">
        <div class="relative">
            <div class="absolute w-full flex justify-center bottom-4">
                <div class="voucher-image rounded-md overflow-hidden">
                    <!-- <div :style="{'background-image': `url('${serialModel.campaignImgUrl}')`}"></div> -->
                    <img :src="getVoucherImg()"/>
                </div>
            </div>
        </div>
        <div>
            <div class="text-center text-16 px-4 " :class="{'border-b ' :value}">
                <div class=" text-black font-semiBold">{{lbl.serial.title}}</div>
                <div v-if="value" class="text-26 pt-2 font-Medium pb-4 border-b" :style="textStyle">{{FilterNumberFormat(value)}} {{lbl.serial.baht}}</div>
                <!-- <div class="text-26 pt-2 font-Medium pb-4 border-b" :style="textStyle">10 {{lbl.serial.baht}}</div> -->
            
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialDetail",
    props: {
        serialModel: Object,
        lbl: Object,
        value: Number,
        blobConfig: Object
    },
    data: function() {
        return {
            textStyle: {
                color : '',
            },
        }
    },
    created: function() {
        this.setupTheme();
    },
    methods: {
        setupTheme: function() {
            this.textStyle.color = this.blobConfig.appConfig.blobConfig.text_color
        },
        getVoucherImg: function() {
            return `${this.blobConfig.blobUrl}/image/${this.blobConfig.appConfig.blobConfig.icon_popup_serial}`;
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    @import '../../../../style/base.scss';
    .font-text {
        font-family: $ff-text;
    }
    .font-Medium {
        font-family: $ff-Medium;
    }
    .font-semiBold {
        font-family: $ff-semi;
    }
    .campaign-image {
        div {
            @include boxRatio(100%);
        }
    }
    .voucher-image {
        max-width: 164px;
    }
</style>
